// Base
import { useEffect } from "react";

// Components
import ProductCardItem from "@/components/Cards/ProductCardItem";

// Store
import { useCartStore } from "@/zustand/cartStore";

// Types
import type { CartProduct } from "@/types/types";

interface ProductCardsProps {
  products: CartProduct[];
}

export default function ProductCards({ products }: ProductCardsProps) {
  const { selectedProduct, setSelectedProduct } = useCartStore();

  const handleChange = (product: CartProduct) => {
    const cartProduct: CartProduct = {
      sku: product.sku?.trim(),
      amount: product.amount,
      konnektive_id: product.konnektive_id?.trim(),
      bundle_products: product.bundle_products,
      warranty_price: product.warranty_price,
      warranty_product_id: product.warranty_product_id,
      display_name: product.display_name,
      generic_name: product.generic_name,
      price: product.price,
      old_price: product.old_price,
      shipping_price: product.shipping_price,
      promo_discounted_price: product.promo_discounted_price,
      promo_shipping_price: product.promo_shipping_price,
    };
    setSelectedProduct(cartProduct);
  };

  useEffect(() => {
    if (products.length && !selectedProduct) {
      const bestSellerProduct = products.find((p) => p.best_seller === true);
      handleChange(bestSellerProduct || products[1]);
    }
  }, [products, selectedProduct]);

  return (
    <div className="flex flex-col gap-2">
      {products.map((product, index) => (
        <div key={`card-${index}`}>
          <ProductCardItem
            index={index}
            product={product}
            active={selectedProduct?.price === product?.price}
            handleChange={() => handleChange(product)}
          />
        </div>
      ))}
    </div>
  );
}
